import { defineNuxtPlugin, useRouter } from '#imports';
import { handleError } from '~/api';

export default defineNuxtPlugin(() => {
  const router = useRouter();

  router.onError(handleError);
});
